var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"40","height":"28","viewBox":"0 6 40 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 7h40v26H0V7z","fill":"#F0F0F0"}}),_c('path',{attrs:{"d":"M20.5 29a8.5 8.5 0 100-17 8.5 8.5 0 000 17z","fill":"#D80027"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }